import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoCanalVendaMultiselectComponent } from './novo-canal-venda-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoCanalVendaMultiselectComponent],
  exports: [NovoCanalVendaMultiselectComponent]
})
export class NovoCanalVendaMultiselectModule {}
